import { validationSchema } from '../validationSchema';
import { langRadioData } from './add-client-mock';

export const emailFieldNames = {
  locale: 'locale',
  client_id: 'client_id',
  subject: 'subject',
  cc: 'cc',
  title: 'title',
  text: 'text',
  attachments: 'attachments',
};

export const textareaValues = {
  [emailFieldNames.subject]: {
    0: 'Sélection immobilière personnalisée',
    1: 'Your personalized properties selection in French Riviera',
    2: 'Персональная подборка недвижимости',
  },
  [emailFieldNames.title]: {
    0: 'Bonjour {firstName} {lastName},',
    1: 'Dear {firstName} {lastName},',
    2: 'Добрый день, {firstName}!',
  },
  [emailFieldNames.text]: {
    0: 'Je vous invite à consulter cette sélection faite pour vous! Merci d`avance pour votre retour.',
    1: 'Please check out this real estate selected for you! Thank you in advance for your feedback.',
    2: 'Пожалуйста, ознакомьтесь с выбранной для вас недвижимостью! Заранее благодарю за обратную связь.',
  },
};

export const initialValues = {
  [emailFieldNames.locale]: '',
  [emailFieldNames.client_id]: '',
  [emailFieldNames.subject]: '',
  [emailFieldNames.cc]: '',
  [emailFieldNames.title]: '',
  [emailFieldNames.text]: '',
  [emailFieldNames.attachments]: [],
};

export const validationSchemaEmail = {
  [emailFieldNames.client_id]: validationSchema.default,
};

export const localeField = {
  id: 1,
  name: emailFieldNames.locale,
  fieldType: 'toggle',
  toggleList: langRadioData,
  className: 'justify-start gap-0 flex-wrap',
  classNames: 'w-full',
};

export const baseFields = [
  {
    id: 3,
    placeholder: 'Recipient CC (optional)',
    name: emailFieldNames.cc,
    fieldType: 'text',
    classNames: 'w-full sm:w-1/2',
  },
];

export const textareaFields = [
  {
    id: 1,
    name: emailFieldNames.subject,
    textareaLabel: 'Email subject',
    fieldType: 'textareaDefaultValue',
    defaultValue: textareaValues[emailFieldNames.subject][1],
    classes: 'h-16',
    classNames: 'w-full sm:w-1/2',
  },
  {
    id: 2,
    name: emailFieldNames.title,
    textareaLabel: 'Title',
    fieldType: 'textareaDefaultValue',
    defaultValue: textareaValues[emailFieldNames.title][1],
    classes: 'h-16',
    classNames: 'w-full sm:w-1/2',
  },
  {
    id: 3,
    name: emailFieldNames.text,
    textareaLabel: 'Text',
    fieldType: 'textareaDefaultValue',
    defaultValue: textareaValues[emailFieldNames.text][1],
    classes: 'h-28',
    classNames: 'w-full sm:w-1/2',
  },
];
